"use client";

/**
 * Staff control for a deal's "project": create/link its Slack project channel
 * and mint/copy the public secure chat link. Calls the employee APIs
 * (session-authed) — `/api/projects/[dealId]/channel` and `/chat-link`.
 *
 * This file is the composition and the one place a failure from any of the four
 * writes is shown. The requests and their state are
 * `./DealProjectChannelCard/useDealProjectChannel`; the two cards are
 * `ProjectChannelCard` and `CustomerChatLinkCard` beside it.
 */

import React from "react";
import { useRoleCheck } from "@/lib/hooks/auth/useRoleCheck";

import { CustomerChatLinkCard } from "./DealProjectChannelCard/CustomerChatLinkCard";
import { ProjectChannelCard } from "./DealProjectChannelCard/ProjectChannelCard";
import { useDealProjectChannel } from "./DealProjectChannelCard/useDealProjectChannel";

export function DealProjectChannelCard({ dealId }: { dealId: string }) {
  const { isAdmin } = useRoleCheck();
  const state = useDealProjectChannel(dealId);

  return (
    <div className="space-y-4">
      {state.error && <p className="text-sm text-destructive">{state.error}</p>}
      <ProjectChannelCard state={state} isAdmin={isAdmin} />
      <CustomerChatLinkCard state={state} />
    </div>
  );
}
